import React from "react";
import { ReportingProvider } from "@veiligh/reporting-core/ui";

import { WebReportingAdapter } from "~/adapters/reporting-adapter";
import { WebReportingAuth } from "~/adapters/reporting-auth";
import { useSelector } from "~/redux/store";

interface ReportsTestProviderProps {
  children: React.ReactNode;
}

export const ReportsNewProvider: React.FC<ReportsTestProviderProps> = ({
  children,
}) => {
  const dataAdapter = React.useMemo(() => new WebReportingAdapter(), []);
  const userId = useSelector((state) => state.persistedReducer.auth.userId);
  const userTokenInfo = useSelector(
    (state) => state.persistedReducer.auth.userTokenInfo,
  );
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions ?? [],
  );

  const authContext = React.useMemo(
    () =>
      new WebReportingAuth(
        () => ({
          id: userId ?? "",
          name:
            `${userTokenInfo?.firstName ?? ""} ${userTokenInfo?.lastName ?? ""}`.trim() ||
            "User",
          email: userTokenInfo?.email,
          accessLevel: String(userTokenInfo?.roles?.[0] ?? "user"),
        }),
        () => permissions.map(String),
      ),
    [permissions, userId, userTokenInfo],
  );

  return (
    <ReportingProvider dataAdapter={dataAdapter} authContext={authContext}>
      {children}
    </ReportingProvider>
  );
};
